import { MouseEvent } from "react";
import { Link } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { isNullOrUndefined, reduce } from "et3-type-guards";
import { fontWeights } from "et3-ui-library";
import { KHATTABAT_HEADER_MENU_ITEMS } from "../../../constants/core-constants";
import i18n from "../../../constants/i18n";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import getCoreUIStore from "../../../stores/core/core-ui-store";
import getDashBoardStore from "../../../stores/dashboard-store";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import HeaderMenuItem from "../HeaderMenuItem";
import { getKhattabatAssignStore } from "../../../stores/khattabat-stores/assign-store";

const KhattabaMenu = withLiteObserverAndTheme(() => {
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const adminIsUnderMaintenance =
    getCorePersonalStore().adminUnderMaintenance.get();

  const isMobileNav = getCoreUIStore().isMobileNav.get();
  const pageName = getCoreHistoryStore().getPageName();
  const isEnabled = isAnyKhattabaAdmin && !adminIsUnderMaintenance;

  const items = KHATTABAT_HEADER_MENU_ITEMS({
    isKhattabaAiAdmin: getCorePersonalStore().isKhattabaAiAdmin.get(),
    totalUnassignedNewClients: reduce(
      () => getKhattabatAssignStore().getTotalUnassignedNewClientsAndTesters.get(),
      0
    ),
    totalMaleUnreadMessages: reduce(
      () => getDashBoardStore().totalMaleUnreadMessages.get(),
      0
    ),
    totalFemaleUnreadMessages: reduce(
      () => getDashBoardStore().totalFemaleUnreadMessages.get(),
      0
    )
  });
  const visibleItems = items.filter((item) => item.isVisible);
  const selectedItem = visibleItems.find((item) => item.page === pageName);

  return (
    <Tabs
      value={isNullOrUndefined(selectedItem) ? false : selectedItem.link}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile={isMobileNav}
      aria-label={i18n.get("MAIN_NAVIGATION")}
      sx={{
        height: "100%",
        minHeight: 0,
        "& .MuiTabs-flexContainer": { height: "100%", gap: 1 }
      }}
    >
      {visibleItems.map((item) => (
        <Tab
          key={item.link}
          value={item.link}
          component={Link}
          to={item.link}
          disabled={!isEnabled}
          onClick={(event: MouseEvent) => {
            if (!isEnabled) event.preventDefault();
          }}
          label={
            <HeaderMenuItem
              text={i18n.get(item.textKey)}
              counter={item.counter}
              isCounterVisible={item.isCounterVisible}
            />
          }
          sx={{
            minHeight: 0,
            minWidth: isMobileNav ? 0 : undefined,
            px: isMobileNav ? 1.5 : undefined,
            textTransform: "none",
            fontWeight: fontWeights.medium,
            "&.Mui-selected": { fontWeight: fontWeights.semibold }
          }}
        />
      ))}
    </Tabs>
  );
});

export default KhattabaMenu;
